/* eslint-disable react/no-danger */
import React from "react";

import Icon from "../../icon/Icon";

import stockNextOrderKeys from "@/constants/stockNextOrderKeys";

import styles from "./product-stock-info.module.scss";

function ProductStockInfo({ productData: { productCode, customerDescription, image, nextOrderKey, estimatedDate } }) {
  return (
    <div className={styles.productStockInfo}>
      <div className={styles.productStockInfo__content}>
        <div className={styles["productStockInfo__product-info"]}>
          <div className={styles["productStockInfo__product-info-left"]}>
            <div className={styles["productStockInfo__product-info-name"]}>{customerDescription}</div>
            <div>
              <b>Product code:</b> {productCode}
            </div>
            <div className={styles["productStockInfo__general-info"]}>
              <div className={styles.productStockInfo__paragraph}>
                <Icon name="store" />
                <p>
                  {!estimatedDate ? (
                    <span>
                      <b>We don&apos;t have an estimate</b> for when we will have the product back in our distribution
                      centre
                    </span>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: stockNextOrderKeys[nextOrderKey],
                      }}
                    />
                  )}
                </p>
              </div>
              <div className={styles.productStockInfo__paragraph}>
                <Icon name="email" />
                <p>
                  Did you know, <b>You can sign up for email me when back in stock</b> in order to get notified on the
                  day it’s available online. You can select one of your recently viewed items below to easily return to
                  the product page in order to do so.
                </p>
              </div>
            </div>
          </div>
          <div className={styles["productStockInfo__product-info-right"]}>
            <img alt={productCode} src={image} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductStockInfo;
